export const AiAutomationPageData = {
  services: [
    {
      title: "AI Workflow Automation",
      description:
        "Bitsclan delivers AI workflow automation professional services that drive speed & consistency across teams. Complex workflows are simplified & tasks that took hours now happen within seconds.",
    },
    {
      title: "AI Marketing Automation",
      description:
        "We automate intelligent campaigns using AI marketing automation services that respond to user behavior in real time. Bitsclan empowers brands to go beyond basic targeting & personalize every interaction.",
    },
    {
      title: "Robotic Process Automation (RPA)",
      description:
        "RPA uses software robots to automate cognitive processes, data manipulation, network monitoring, multiple system tasks, repetitive tasks, & high-volume tasks. We provide RPA services that streamline workflows & improve business efficiency.",
    },
    {
      title: "n8n Workflow Automation & Integrations Services",
      description:
        "At Bitsclan, we provide best n8n workflow automation services that combine AI capabilities with business process automation. Our solutions give technical teams the flexibility of code with the speed of no-code. We integrate n8n with 500+ popular tools including Google Sheets, Trello, Slack, Jira, & HubSpot, enabling seamless automation across your business workflows.",
    },
    {
      title: "AI Automation Consulting & Testing",
      description:
        "Bitsclan’s AI Automation Consulting & Testing services help businesses define automation strategies, optimize workflows, & select the right AI models. We ensure reliability through advanced testing, validating performance, & securing scalable, efficient, & growth-ready automation solutions.",
    },
  ],
  trendingInsights: {
    heading: "Insights That Shape the Future of Automation",
    description:
      "Learn the latest in AI, automation & workflow services. Get practical insights, expert opinions, & strategies to stay ahead in the tech landscape.",
  },
  roadmapContent: {
    mainHeading: "Our Proven AI ML Development Roadmap to ",
    // greenHeading: "Ensure Your Success",
    sectionDescription:
      "As a leading ai development company in usa, we have developed a structured roadmap to ensure the success of your projects. From initial discovery to ongoing support, we follow a systematic approach that guarantees alignment with your business goals, delivers high-quality solutions, & provides continuous improvement. Here’s how we do it:",
  },
  faqSection: {
    heading: "Your Questions on AI Automation, Answered",
    questionAnswers: [
      {
        id: "faq1",
        question: "What is AI Automation & Workflow?",
        answer:
          "AI automation utilizes intelligent systems to automatically perform repetitive or complex tasks. Workflows are the steps taken for these tasks. Together, they can improve processes, save time, & enhance efficiency.",
      },
      {
        id: "faq2",
        question: "What is the cost of AI workflow automation services?",
        answer:
          "The price of AI workflow automation depends on factors like task complexity, solution type (custom-built or ready-made), & implementation scale. Simple automation projects may start at a few thousand dollars, while large enterprise solutions can reach tens of thousands. For precise pricing, it’s best to request a quote from the best automation agency.",
      },
      {
        id: "faq3",
        question:
          "How Does the AI & Automation Service at Bitsclan Guarantee ROI?",
        answer:
          "At Bitsclan we guarantee you measurable ROI by assessing the time & cost savings of each AI or automation solution prior to implementing, allowing us to focus on implementations that provide maximum value to you. Our solutions are designed to alleviate repetitive processes/deployment ways, while AI provides faster & consistent decisions for your team. Thus freeing up your time & resources to focus on revenue-generating activities.",
      },
      {
        id: "faq4",
        question:
          "Can your AI solutions integrate with current tools & software?",
        answer:
          "Absolutely, our AI based workflow management can integrate with most platforms. We utilize APIs, no-code tools & custom code to facilitate integrations.",
      },
      {
        id: "faq5",
        question:
          "Will you train my team on how to use the Al solutions?",
        answer:
          "Yes! We provide full training sessions & documentation so your team can manage, handle & most importantly, optimize AI automation tools during a smooth changeover & at the highest level of proficiency.",
      },
      {
        id: "faq6",
        question:
          "Why should I pick your agency for Al automation solutions?",
        answer:
          "It's simple, we design artificial intelligent automation solutions that save you time, save you money, increase your productivity, & help you grow. We operate in a transparent manner, have specialized teams in AI automation & have successful case studies to prove we can help your organization effectively implement Al with a demonstrable return on investment. ",
      },
    ],
  },
  companyCta: {
    heading: "Want to scale customer interactions using AI chatbots?",
    subHeading: "See how our expert developers can help.",
    buttonText: "Schedule a Call",
  },
  engagementModels: {
    shortHeading: "Your Goals. Our Flexible Approach",
    heading: "Looking for AI Automation & Workflow Expertise?",
    subheading:
      "Choosing the right engagement model is key to the success of any automation project. Whether you need full-time, part-time, or hourly AI automation or n8n workflow experts, we provide flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    models: [
      {
        index: "1.",
        title: "Team Augmentation",
        description:
          "Augment your team with skilled AI automation professionals to fill expertise gaps & scale workflow solutions efficiently for your business.",
        icon: "/images/engagement-model-gifs/hourly-icon.svg",
        iconWidth: 40,
      },
      {
        index: "2.",
        title: "Dedicated Teams",
        description:
          "A full-time AI automation team dedicated solely to your workflows, ensuring AI solutions align perfectly with your business goals.",
        icon: "/images/engagement-model-gifs/price-icon.svg",
        iconWidth: 35,
      },
      {
        index: "3.",
        title: "Reliable Automation Delivery",
        description:
          "Perfect for AI automation & workflow initiatives with defined objectives & timelines. Let Bitsclan handle the entire journey, from strategy to complete execution.",
        icon: "/images/engagement-model-gifs/retainer-icon.svg",
        iconWidth: 40,
      },
    ],
    cta: {
      text: "Talent on Your Terms",
      button: " Automate Your Project",
      link: "https://calendly.com/bitsclan-it/30min?",
      nextTab: true
    },
  },
  industries: {
    shortHeading: "",
    heading: "",
    description: "",
    serviceTags: [
      { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
      { title: "AI Automation", link: "/ai-automation-agency" },
      { title: "Generative AI", link: "/generative-ai-development-services" }
    ],
    tabData: [
      {
        id: 1,
        slug: "healthcare",
        title: "Healthcare",
        description: "We specialize in healthcare AI automation services & consulting. Our team develops automated workflows that integrate with EHR systems & patient management tools to improve care delivery, streamline operations, & ensure compliance with industry standards.",
        image: "healthcare.avif",
        icon: "/images/heart.png",
      },
      // {
      //   id: 2,
      //   slug: "fintech",
      //   title: "Fintech",
      //   description: "We provide AI automation solutions allowing fintech to manage a range of routine inquiries, transactions, & account changes reliably & accurately. You'll enjoy peace of mind regarding safe payments, & will realize fast, real-time financial intelligence via web & mobile applications.",
      //   image: "fintech.png",
      //   icon: "/images/Fintech.png",
      // },
      {
        id: 3,
        slug: "retail-ecommerce",
        title: "E-commerce & Retail",
        description: "Through our E-commerce & Retail AI automation services, we create streamlined workflows that enhance response times, automate product recommendations, & reduce the complexity of checkout flows. We enable brands to reach customers effectively while increasing sales & enhancing loyalty.",
        icon: "/images/ecommerce-icon.png",
        image: "ecommerce.avif",
      },
      {
        id: 4,
        slug: "real-estate",
        title: "Real Estate",
        description: "We assist real estate professionals in automating operations using AI based workflows. Our intelligent bots simplify operations from property & project management & client relationship management systems to safe transactions & exchanges in a friendly manner.",
        icon: "/images/RealEstate.png",
        image: "realestate.avif",
      },
      {
        id: 5,
        slug: "automotive-logistics",
        title: "Automotive & Logistics",
        description: "Our AI automation & workflow solutions empower the automotive & logistics industries by streamlining vehicle tracking, fleet management, supply chains, & inventory workflows. From managing operations & customer communications to real-time updates & seamless coordination, we help businesses boost efficiency, reduce complexity, & deliver a smoother experience for everyone.",
        icon: "/images/automotive-icon.png",
        image: "automotive.avif",
      },
      {
        id: 6,
        slug: "education",
        title: "Education",
        description: "We believe learning should be seamless & efficient, & our AI automation & workflow solutions make it possible. From automating administrative tasks to managing classroom operations, we design intelligent workflows that support students, educators, & institutions, helping everyone achieve better outcomes.",
        icon: "/images/education-icon.png",
        image: "education.avif",
      },
      {
        id: 9,
        slug: "gaming-entertainment",
        title: "Entertainment & Gaming",
        description: "We empower the entertainment & gaming industries with AI-driven solutions that transform audience engagement & gaming experiences. From intelligent content management & real-time audience insights to in-game automation & immersive player interactions, our services help brands deliver captivating entertainment, streamline operations, & build stronger connections with their communities.",
        icon: "/images/industry-gaming-icon.png",
        image: "entertainmentMain.avif",
      }
      // {
      //   id: 11,
      //   slug: "social-networking",
      //   title: "Social Networking",
      //   description: "We deliver AI automation & workflow solutions for social media platforms, increasing engagement, automating analytics, & ensuring secure data management. Our AI services enhance interactions while keeping processes efficient & secure.",
      //   icon: "/images/SocialNetworking.png",
      //   image: "Social.png",
      // },
      // {
      //   id: 12,
      //   slug: "telecom",
      //   title: "Telecom",
      //   description: "Our AI automation services for the telecom sector streamline processes like billing management, network optimization, & customer relationship operations. By automating these workflows, we help telecom companies improve efficiency, reduce errors, & deliver consistently better experiences to their customers.",
      //   icon: "/images/Telecom.png",
      //   image: "telecom.png",
      // },
      // {
      //   id: 13,
      //   slug: "energy",
      //   title: "Energy",
      //   description: "We provide advanced AI automation & workflow solutions for the energy sector. From smart grid management & resource optimization to secure trading platforms, our automated workflows help energy companies operate smarter & more efficiently.",
      //   icon: "/images/Energy.png",
      //   image: "energy.png",
      // },
      // {
      //   id: 14,
      //   slug: "agriculture",
      //   title: "Agriculture",
      //   description: "Our smart automation solutions in the agricultural industry, help farmers optimize irrigation, monitor crops efficiently, & manage resources effectively. It can boost yields & support sustainable farming practices.",
      //   icon: "/images/industries-icons/Agriculture.svg",
      //   image: "Agriculture.avif",
      // }
    ]
  },
  techStack: {
    tabs: [
      "AI Automation Tools",
      "Modules/Toolkits",
      "Deep Learning (DL) Frameworks",
      "Neural Networks",
      "Libraries",
      "Image Classification Models",
    ],

    tabItems: [
      {
        tab: "AI Automation Tools",
        icon: "/images/ai-automation-agency-tech-stack-icons/chatgpt.png",
      },
      {
        tab: "AI Automation Tools",
        icon: "/images/ai-automation-agency-tech-stack-icons/dall-e.png",
      },
      {
        tab: "AI Automation Tools",
        icon: "/images/ai-automation-agency-tech-stack-icons/google.png",
      },
      { tab: "AI Automation Tools", icon: "/images/ai-automation-agency-tech-stack-icons/hubspot.png", },
      { tab: "AI Automation Tools", icon: "/images/ai-automation-agency-tech-stack-icons/m365.png", },
      { tab: "AI Automation Tools", icon: "/images/ai-automation-agency-tech-stack-icons/perplexity.png", },
      { tab: "AI Automation Tools", icon: "/images/ai-automation-agency-tech-stack-icons/stack.png", },
      { tab: "AI Automation Tools", icon: "/images/ai-automation-agency-tech-stack-icons/zapier.png" },
      {
        tab: "Modules/Toolkits",
        icon: "/images/genai6.svg",
      },
      {
        tab: "Modules/Toolkits",
        icon: "/images/module1.svg",
      },
      {
        tab: "Modules/Toolkits",
        icon: "/images/module2.svg",
      },
      {
        tab: "Modules/Toolkits",
        icon: "/images/module3.svg",
      },
      {
        tab: "Modules/Toolkits",
        icon: "/images/module4.svg",
      },
      {
        tab: "Deep Learning (DL) Frameworks",
        icon: "/images/tech-icon.svg",
      },
      {
        tab: "Deep Learning (DL) Frameworks",
        icon: "/images/tech-icon2.svg",
      },
      {
        tab: "Deep Learning (DL) Frameworks",
        icon: "/images/tech-icon3.svg",
      },
      {
        tab: "Deep Learning (DL) Frameworks",
        icon: "/images/tech-icon4.svg",
      },
      {
        tab: "Deep Learning (DL) Frameworks",
        icon: "/images/tech-icon5.svg",
      },
      { tab: "Neural Networks", icon: "/images/natural1.svg" },
      { tab: "Neural Networks", icon: "/images/natural2.svg" },
      {
        tab: "Neural Networks",
        icon: "/images/natural7.svg",
      },
      {
        tab: "Neural Networks",
        icon: "/images/natural4.svg",
      },
      { tab: "Neural Networks", icon: "/images/natural5.svg" },
      { tab: "Neural Networks", icon: "/images/natural6.svg" },
      { tab: "Libraries", icon: "/images/tech-icon.svg", },
      { tab: "Libraries", icon: "/images/tech-icon2.svg" },
      { tab: "Libraries", icon: "/images/tech-icon3.svg", },
      { tab: "Libraries", icon: "/images/libraries1.svg", },
      { tab: "Libraries", icon: "/images/libraries2.svg", },
      { tab: "Libraries", icon: "/images/libraries3.svg", },
      { tab: "Libraries", icon: "/images/libraries4.svg", },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification2.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification3.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification4.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification5.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification6.svg",
      },
      {
        tab: "Image Classification Models",
        icon: "/images/calsification7.svg",
      },
    ]
  },

  testimonials: [
    {
      name: "Michael Turner",
      enterprise: "Enterprise Automation",
      country: "Austin, US",
      countryFlagImage: "/images/testimonials/flags/usa-flag.png",
      designation: "CTO at BrightPath Logistics",
      profileImage: "/images/testimonials/michael.avif",
      logoImage: "/images/logo-2.png",
      text: "Bitsclan built a chatbot that now handles most of our customer queries. Response times are down to seconds, & our support team is free to focus on complex issues. It’s been a huge boost to efficiency & customer satisfaction.",
      serviceTags: [
        { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
        { title: "AI Automation", link: "/ai-automation-agency" },
        { title: "Generative AI", link: "/generative-ai-development-services" }
      ]
    },
    {
      name: "Sophie Keller",
      enterprise: "Healthcare AI",
      country: "Florida, US",
      countryFlagImage: "/images/testimonials/flags/usa-flag.png",
      designation: "Head of Digital Transformation at Meditech Solutions",
      profileImage: "/images/testimonials/sophie.avif",
      logoImage: "/images/logo-2.png",
      text: "With Bitsclan’s agentic AI, we’ve automated routine admin tasks like scheduling & reporting. Our staff now spends more time with patients, & errors have dropped noticeably. The solution fit right into our workflow.",
      serviceTags: [
        { title: "Chat bots & Virtual Agents", link: "/ai-chatbot-development-services" },
        { title: "AI Automation", link: "/ai-automation-agency" },
        { title: "Generative AI", link: "/generative-ai-development-services" }
      ]
    },
    {
      name: "Sarah Coleman",
      enterprise: "Construction & Industrial Equipment",
      country: "Illinois, US",
      countryFlagImage: "/images/testimonials/flags/usa-flag.png",
      designation: "Training & Product Specialist at American Moisture Test",
      profileImage: "/images/testimonials/sarah.avif",
      logoImage: "/images/testimonials/logo-amt.png",
      text: "Partnering with Bitsclan allowed us to digitize our testing workflow. From product tracking to client reporting, everything is now managed in one unified system. The team’s industrial understanding and precision execution exceeded our expectations.",
      serviceTags: [
        { title: "Custom Web Development", link: "/custom-software-development-services" },
        { title: "Equipment Management System", link: "#" },
        { title: "ERP Integration", link: "#" }
      ]
    }
  ]
};
